import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Kicker, Divider } from './ui/Typography';
import { useT } from '../i18n/LanguageContext';
export function HeroSection() {
  const t = useT().hero;
  return <Section hasOrb={true} className="pt-32 pb-20 sm:pt-40 lg:pt-48" data-id="element-87">
      <div className="max-w-4xl" data-id="element-88">
        {/* 2026 EDITION badge */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="inline-block bg-brand text-black font-mono font-bold text-xs px-3 py-1.5 rounded-[6px] uppercase tracking-[0.18em] mb-8" data-id="element-89">
          {t.badge}
        </motion.div>

        <Kicker data-id="element-90">{t.kicker}</Kicker>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="font-archivo uppercase leading-[0.92] tracking-tighter text-[clamp(40px,9vw,96px)]" data-id="element-91">
          {t.title1} <span className="text-brand" data-id="element-92">{t.title2}</span> {t.title3}
        </motion.h1>

        <Divider data-id="element-93" />

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="text-ink-dim text-xl sm:text-2xl max-w-2xl mb-12 leading-relaxed" data-id="element-94">
          {t.subtitle}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="grid grid-cols-3 gap-4 sm:gap-6 mb-12 max-w-2xl" data-id="element-95">
          {t.stats.map((stat, i) => <div key={i} className="flex items-center gap-3" data-id="element-96">
              <span className="font-archivo text-brand text-3xl sm:text-4xl lg:text-5xl" data-id="element-97">
                {stat.num}
              </span>
              <span className="font-mono text-ink-dim text-xs sm:text-sm uppercase tracking-widest leading-tight" data-id="element-98">
                / {stat.label}
              </span>
            </div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="flex flex-col items-start gap-4" data-id="element-99">
          <Button testId="hero-cta" className="w-full sm:w-auto" scrollTo="offer" data-id="element-100">
            {t.cta}
          </Button>
          <p className="text-ink-dim text-sm" data-id="element-101">
            <span className="line-through opacity-50 mr-2" data-id="element-102">$34</span>
            {t.priceNote}
          </p>
        </motion.div>
      </div>
    </Section>;
}